<template>
  <v-card outlined>
    <v-card-text
      v-cloak
      @drop.prevent="addDropFile"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-3': dragover }"
    >
      <div class="flex">
        <div class="w-full h-auto relative">
          <div class="d-flex flex-column justify-center align-center pa-2">
            <v-avatar color="primary" rounded class="mb-2">
              <v-icon color="white">mdi-upload</v-icon>
            </v-avatar>
            <h5 class="text-h5">
              {{
                multiple ? "Ziehe Dateien hierher" : "Ziehe eine Datei hierher"
              }}
            </h5>
            <span class="mt-2 mb-3">oder</span>
            <v-btn depressed outlined text @click="onFileClick">
              {{ multiple ? "Dateien auswählen" : "Datei auswählen" }}
            </v-btn>
            <input
              type="file"
              ref="fileInput"
              v-show="false"
              @change="onFileChange"
              :multiple="multiple"
              :accept="acceptedFileTypes.join(',')"
            />
            <div v-if="unsupportedFileTypeMessage" class="error--text">
              {{ unsupportedFileTypeMessage }}
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-divider v-if="files.length"></v-divider>
    <v-card-text v-if="files.length">
      <div class="mb-2">
        {{ multiple ? "Ausgewählte Dateien" : "Ausgewählte Datei" }}
      </div>
      <v-row class="match-height">
        <template v-for="(file, index) in files">
          <v-col cols="12" sm="6" :key="index">
            <v-card :ripple="false" outlined>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon>mdi-file</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ file.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ formatFileSize(file.size) }}</v-list-item-subtitle
                  >
                </v-list-item-content>
                <v-list-item-action
                  ><v-btn
                    text
                    color="error"
                    block
                    @click.stop="removeFile(index)"
                  >
                    <v-icon left small>mdi-delete</v-icon>Löschen
                  </v-btn></v-list-item-action
                >
              </v-list-item>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "file-upload-dropzone",
  props: {
    files: {},
    acceptedFileTypes: {
      type: Array,
      default: () => ["*"], // Allow all file types by default
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dragover: false,
      unsupportedFileTypeMessage: "",
    };
  },
  model: {
    prop: "files",
    event: "filesChange",
  },
  computed: {
    filesLocal: {
      get: function () {
        return this.files;
      },
      set: function (value) {
        this.$emit("filesChange", value);
      },
    },
  },
  methods: {
    addDropFile(e) {
      this.dragover = false;
      const files = Array.from(e.dataTransfer.files).filter(this.checkFileType);
      if (!this.multiple) {
        // In single-file mode, replace any existing file
        this.filesLocal = files.length > 0 ? [files[0]] : this.filesLocal;
      } else {
        this.filesLocal = [...this.filesLocal, ...files];
      }
    },
    removeFile(index) {
      if (index > -1) {
        const updated = [...this.files];
        updated.splice(index, 1);
        this.filesLocal = updated;
      }
    },
    checkFileType(file) {
      const fileType = file.type;
      const mainType = fileType.split("/")[0];
      const fileName = file.name || "";
      const fileExtension = fileName.includes(".")
        ? "." + fileName.split(".").pop().toLowerCase()
        : "";

      const isAccepted =
        this.acceptedFileTypes.includes("*") ||
        this.acceptedFileTypes.includes(fileType) ||
        this.acceptedFileTypes.includes(`${mainType}/*`) ||
        (fileExtension && this.acceptedFileTypes.includes(fileExtension));

      if (!isAccepted) {
        this.unsupportedFileTypeMessage = `Unzulässiges Dateiformat: ${
          fileExtension || fileType
        }`;
        return false;
      }
      this.unsupportedFileTypeMessage = "";
      return true;
    },
    onFileClick() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const files = Array.from(e.target.files).filter(this.checkFileType);
      if (!this.multiple) {
        this.filesLocal = files.length > 0 ? [files[0]] : this.filesLocal;
      } else {
        this.filesLocal = [...this.filesLocal, ...files];
      }
      this.$refs.fileInput.value = null; // Reset the input to allow selecting the same file again
    },
    formatFileSize(bytes) {
      if (bytes === 0) return "0 B";
      const units = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      const size = (bytes / Math.pow(1024, i)).toFixed(i > 0 ? 1 : 0);
      return `${size} ${units[i]}`;
    },
  },
};
</script>
